import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import '@fontsource-variable/inter';
import '@meridian/tokens/tokens.css';
import './styles/ops.css';
import { startServiceWorker } from './pwa/register.js';
import { SessionGate } from './session.js';
import { OpsShell } from './shell/OpsShell.js';
import { Compose } from './screens/Compose.js';
import { JobsSplit } from './screens/Jobs.js';
import { Review } from './screens/Review.js';
import { BlocksPage } from './screens/BlocksPage.js';
import { Releases, CandidateDetail } from './screens/Releases.js';
import { CeremonyHost } from './screens/releases/CeremonyHost.js';
import { Notifications } from './screens/Notifications.js';
import { History } from './screens/History.js';
import { Settings } from './screens/Settings.js';
import { More } from './screens/More.js';
import { Capacity } from './screens/Capacity.js';

startServiceWorker();

const router = createBrowserRouter([
  {
    element: <OpsShell />,
    children: [
      { path: '/', element: <Compose /> },
      { path: '/jobs', element: <JobsSplit /> },
      { path: '/jobs/:id', element: <JobsSplit /> },
      { path: '/review/:id', element: <Review /> },
      { path: '/releases', element: <Releases /> },
      { path: '/releases/:runId', element: <CandidateDetail /> },
      { path: '/releases/:runId/promote', element: <CeremonyHost /> },
      { path: '/blocks', element: <BlocksPage /> },
      { path: '/notifications', element: <Notifications /> },
      { path: '/capacity', element: <Capacity /> },
      { path: '/history', element: <History /> },
      { path: '/settings', element: <Settings /> },
      { path: '/more', element: <More /> },
      { path: '*', element: <Compose /> },
    ],
  },
]);

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SessionGate>
      <RouterProvider router={router} />
    </SessionGate>
  </React.StrictMode>,
);
